import React from "react";
import "./PublishingConsultingProcess.css";

const consultingStagesData = [
  {
    stepNumber: 1,
    weekRange: "1-2주",
    title: "기획 단계 컨설팅",
    headerColor: "#42A5F5",
    details: [
      {
        subtitle: "주제 선정 및 분석",
        items: ["주제의 시장성 검토", "타겟 독자층 명확화"],
      },
      {
        subtitle: "경쟁 분석",
        items: ["경쟁 도서 리서치", "차별화 전략 수립"],
      },
    ],
  },
  {
    stepNumber: 2,
    weekRange: "3-6주",
    title: "원고 작성 컨설팅",
    headerColor: "#2196F3",
    details: [
      {
        subtitle: "구성 및 체계",
        items: ["목차 구성의 논리적 흐름", "장/절 배치의 적절성"],
      },
      {
        subtitle: "가독성 향상",
        items: ["문체의 일관성", "독자 수준에 맞는 표현"],
      },
    ],
  },
  {
    stepNumber: 3,
    weekRange: "7-10주",
    title: "출판 프로세스 컨설팅",
    headerColor: "#1E88E5",
    details: [
      {
        subtitle: "편집 및 디자인",
        items: ["교정/교열 업체 선정", "표지/내지 디자인 가이드"],
      },
      {
        subtitle: "등록 및 절차",
        items: ["ISBN 발급 절차", "법적 요구사항 준수"],
      },
    ],
  },
  {
    stepNumber: 4,
    weekRange: "11-12주",
    title: "마케팅 및 유통 컨설팅",
    headerColor: "#1976D2",
    details: [
      {
        subtitle: "유통 채널",
        items: ["온라인 서점 입점", "오프라인 유통 전략"],
      },
      {
        subtitle: "디지털 마케팅",
        items: ["SNS 활용 전략", "온라인 광고 운영"],
      },
    ],
  },
];

const PublishingConsultingProcess = () => {
  return (
    <div className="publishing-consulting-container">
      <div className="consulting-intro">
        <h1 className="consulting-intro-title">출판 컨설팅이란?</h1>
        <p className="consulting-intro-description">
          출판 컨설팅은 자비 출판을 준비하는 저자에게 전문적인 출판사에서
          출판 프로세스 가이드를 제공하는 서비스입니다.
        </p>
      </div>

      <h2 className="process-main-title">출판 컨설팅 과정</h2>

      <div className="consulting-process-timeline">
        <div className="timeline-bar">
          <div className="timeline-line"></div>
          {consultingStagesData.map((stage, index) => (
            <div key={index} className="timeline-step">
              <div className="timeline-circle">{stage.stepNumber}</div>
            </div>
          ))}
        </div>

        <div className="timeline-content-grid">
          {consultingStagesData.map((stage, index) => (
            <div key={index} className="process-stage-column">
              <div
                className="process-header-card"
                style={{ backgroundColor: stage.headerColor }}
              >
                <p className="week-range">{stage.weekRange}</p>
                <h3 className="card-title">{stage.title}</h3>
              </div>
              <div className="process-body-card">
                {stage.details.map((detail, detailIndex) => (
                  <div key={detailIndex} className="card-detail-section">
                    <h4 className="detail-subtitle">{detail.subtitle}</h4>
                    <ul className="detail-list">
                      {detail.items.map((item, itemIndex) => (
                        <li key={itemIndex}>{item}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PublishingConsultingProcess;
